import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiRoutes } from '../../constants';
import { AspNetUser } from '../../models';

@Injectable({
    providedIn: 'root',
})
export class UserApiService {
    http = inject(HttpClient);

    getAspNetUser() {
        return this.http.get<{
            success: boolean;
            data: AspNetUser;
            error?: string;
        }>(`${ApiRoutes.aspNetUser}GetAspNetUser`);
    }
}
